<template>
  <require from="controls/bs-form-select"></require>

  <bs-form-select label.bind="label" placeholder="Please select the region you reside in" value.bind="model.regionDirector & validate:regionDirectorPanelRules" options.bind="regionDirectors" matcher.bind="keywordsItemMatcher" name-path="region" disabled.bind="disabled"></bs-form-select>  
</template>
